"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/OMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_178)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_178`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3.12 0H32.88V24H-3.12V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.56421 0H33.0203V8H6.56421V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.56421 16.1404H33.0203V24.1404H6.56421V16.1404Z",
					fill: "#4A7C3A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.29187 2.47021C-0.29187 2.47021 2.31164 5.83864 3.27304 6.29478C4.23445 6.75092 4.47304 6.69478 4.47304 6.69478",
					stroke: "white",
					strokeWidth: .701754,
					strokeMiterlimit: 2
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.89758 2.47021C3.89758 2.47021 1.29407 5.65618 0.620386 6.14741C-0.053298 6.63864 -0.691895 6.69478 -0.691895 6.69478M0.508106 4.5825H3.16775M1.84144 2.47021V4.5825",
					stroke: "white",
					strokeWidth: .701754,
					strokeMiterlimit: 2
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_178`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as OMFlag };
